import React from "react";
var ArrowDownSvg = function ArrowDownSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.2935 0V19.2791L19.795 13.0752C20.3001 12.5932 21.1161 12.5932 21.6212 13.0752C22.1263 13.5572 22.1263 14.3357 21.6212 14.8177L11.9984 24L2.37559 14.8177C2.11656 14.5705 2 14.2616 2 13.9403C2 13.6189 2.12951 13.31 2.37559 13.0628C2.88069 12.5808 3.69662 12.5808 4.20172 13.0628L10.7033 19.2791V0H13.2935Z",
    fill: "currentColor"
  }));
};
ArrowDownSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ArrowLeftSvg = function ArrowLeftSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.71403 10.8358L10.9304 4.98446C11.4126 4.52987 11.4126 3.79553 10.9304 3.34094C10.4481 2.88635 9.66916 2.88635 9.18694 3.34094L0 12.0015L9.18694 20.662C9.43424 20.8951 9.74335 21 10.0648 21C10.3863 21 10.6954 20.8834 10.9427 20.662C11.4249 20.2074 11.4249 19.473 10.9427 19.0185L4.71113 13.1671H24V10.8358H4.71403Z",
    fill: "currentColor"
  }));
};
ArrowLeftSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ArrowRightSvg = function ArrowRightSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.8358H19.2643L13.0696 4.98446C12.5873 4.52987 12.5873 3.79553 13.0696 3.34094C13.5518 2.88635 14.3308 2.88635 14.813 3.34094L24 12.0015L14.813 20.662C14.5657 20.8951 14.2566 21 13.9351 21C13.6136 21 13.3045 20.8834 13.0572 20.662C12.575 20.2074 12.575 19.473 13.0572 19.0184L19.2643 13.1671H0V10.8358Z",
    fill: "currentColor"
  }));
};
ArrowRightSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ArrowUpSvg = function ArrowUpSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.2712 4.73574L5.09471 10.9304C4.61486 11.4127 3.83973 11.4127 3.35988 10.9304C2.88004 10.4482 2.88004 9.66924 3.35988 9.18701L12.5015 0L21.6432 9.18701C21.8893 9.43431 22 9.74341 22 10.0649C22 10.3864 21.877 10.6955 21.6432 10.9428C21.1633 11.425 20.3882 11.425 19.9084 10.9428L13.7319 4.7357V24H11.2712V4.73574Z",
    fill: "currentColor"
  }));
};
ArrowUpSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ChevronDownSvg = function ChevronDownSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M23.5757 7.53227L12.0073 19L0.43888 7.53227C-0.146293 6.95219 -0.146293 6.01514 0.43888 5.43506C1.02405 4.85498 1.96933 4.85498 2.55451 5.43506L11.9923 14.7907L21.4301 5.43506C22.0153 4.85498 22.9605 4.85498 23.5457 5.43506C24.1373 6.02151 24.1551 6.92776 23.5757 7.53227Z",
    fill: "currentColor"
  }));
};
ChevronDownSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ChevronLeftSvg = function ChevronLeftSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M16.4677 23.5757L5 12.0073L16.4677 0.43888C17.0478 -0.146293 17.9849 -0.146293 18.5649 0.43888C19.145 1.02405 19.145 1.96934 18.5649 2.55451L9.2093 11.9923L18.5649 21.4301C19.145 22.0153 19.145 22.9605 18.5649 23.5457C17.9785 24.1373 17.0722 24.155 16.4677 23.5757Z",
    fill: "currentColor"
  }));
};
ChevronLeftSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ChevronRightSvg = function ChevronRightSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.53227 23.5757L19 12.0073L7.53227 0.43888C6.95219 -0.146293 6.01514 -0.146293 5.43506 0.43888C4.85498 1.02405 4.85498 1.96934 5.43506 2.55451L14.7907 11.9923L5.43506 21.4301C4.85498 22.0153 4.85498 22.9605 5.43506 23.5457C6.02152 24.1373 6.92776 24.155 7.53227 23.5757Z",
    fill: "currentColor"
  }));
};
ChevronRightSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ChevronUpSvg = function ChevronUpSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M23.5757 16.4677L12.0073 5L0.43888 16.4677C-0.146293 17.0478 -0.146293 17.9849 0.43888 18.5649C1.02405 19.145 1.96933 19.145 2.55451 18.5649L11.9923 9.20931L21.4301 18.5649C22.0153 19.145 22.9605 19.145 23.5457 18.5649C24.1373 17.9785 24.1551 17.0722 23.5757 16.4677Z",
    fill: "currentColor"
  }));
};
ChevronUpSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var CloseSvg = function CloseSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.1992 12.0019L22.5091 3.67858C23.1217 3.06495 23.1217 2.07385 22.5091 1.46022C21.8965 0.846593 20.9068 0.846593 20.2942 1.46022L11.9843 9.78339L3.6744 1.46022C3.06176 0.846593 2.07212 0.846593 1.45948 1.46022C0.84684 2.07385 0.84684 3.06495 1.45948 3.67858L9.76937 12.0019L1.45948 20.3253C0.84684 20.9389 0.84684 21.93 1.45948 22.5437C1.77365 22.8583 2.16637 23 2.57479 23C2.98322 23 3.37594 22.8426 3.69011 22.5437L11.9838 14.2205L20.3099 22.5437C20.6241 22.8583 21.0168 23 21.4252 23C21.8336 23 22.2263 22.8426 22.5405 22.5437C23.1532 21.93 23.1532 20.9389 22.5405 20.3253L14.1992 12.0019Z",
    fill: "currentColor"
  }));
};
CloseSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var HomeSvg = function HomeSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M21.2 8.95997L13 2.79997C12.7 2.57997 12.35 2.46997 12 2.46997C11.65 2.46997 11.3 2.57997 11 2.79997L2.8 8.95997C2.3 9.33997 2 9.92997 2 10.56V22.01H22V10.56C22 9.92997 21.7 9.33997 21.2 8.95997ZM9.3 20.7V14.3H14.7V20.7H9.3ZM20.7 20.7L16 20.7V13H8V20.7H3.3V10.55C3.3 10.33 3.4 10.12 3.58 9.98997L11.78 3.83997C11.86 3.77997 11.94 3.76997 12 3.76997C12.06 3.76997 12.14 3.77997 12.22 3.83997L20.42 9.99997C20.6 10.13 20.7 10.34 20.7 10.56V20.7Z",
    fill: "currentColor"
  }));
};
HomeSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var InformationSvg = function InformationSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 1C5.92 1 1 5.93 1 12C1 18.07 5.92 23 12 23C18.08 23 23 18.08 23 12C23 5.92 18.08 1 12 1ZM13 19H11V10H13V19ZM12 8C11.17 8 10.5 7.33 10.5 6.5C10.5 5.67 11.17 5 12 5C12.83 5 13.5 5.67 13.5 6.5C13.5 7.33 12.83 8 12 8Z",
    fill: "currentColor"
  }));
};
InformationSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var PadlockSvg = function PadlockSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M20.01 10.98C19.35 10.76 18.68 10.56 18 10.39V8C18 4.69 15.31 2 12 2C8.69 2 6 4.69 6 8V10.39C5.32 10.56 4.65 10.76 3.99 10.98C3.39 11.18 3 11.76 3 12.39V20.5C3 21.33 3.67 22 4.5 22H19.5C20.33 22 21 21.33 21 20.5V12.39C21 11.76 20.61 11.18 20.01 10.98ZM7.3 8C7.3 5.41 9.41 3.29999 12 3.29999C14.59 3.29999 16.7 5.41 16.7 8V10.11C15.18 9.80999 13.61 9.64001 12 9.64001C10.39 9.64001 8.82 9.80999 7.3 10.11V8ZM19.7 20.5C19.7 20.61 19.61 20.7 19.5 20.7H4.5C4.39 20.7 4.3 20.61 4.3 20.5V12.39C4.3 12.31 4.35 12.23 4.41 12.21C6.88 11.37 9.43 10.94 12 10.94C14.57 10.94 17.12 11.37 19.59 12.21C19.65 12.23 19.7 12.31 19.7 12.39V20.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.25C11.64 13.25 11.35 13.54 11.35 13.9V18H12.65V13.9C12.65 13.54 12.36 13.25 12 13.25Z",
    fill: "currentColor"
  }));
};
PadlockSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MenuSvg = function MenuSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.5H24V4.5H0V1.5ZM24 10.5H0V13.5H24V10.5ZM24 19.5H0V22.5H24V19.5Z",
    fill: "currentColor"
  }));
};
MenuSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MinusSvg = function MinusSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 13.5H1.5C0.675 13.5 0 12.825 0 12C0 11.175 0.675 10.5 1.5 10.5H22.5C23.325 10.5 24 11.175 24 12C24 12.825 23.325 13.5 22.5 13.5Z",
    fill: "currentColor"
  }));
};
MinusSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var NegativeSvg = function NegativeSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 1C5.92 1 1 5.93 1 12C1 18.07 5.92 23 12 23C18.08 23 23 18.08 23 12C23 5.92 18.08 1 12 1ZM11 5H13V14H11V5ZM12 19C11.17 19 10.5 18.33 10.5 17.5C10.5 16.67 11.17 16 12 16C12.83 16 13.5 16.67 13.5 17.5C13.5 18.33 12.83 19 12 19Z",
    fill: "currentColor"
  }));
};
NegativeSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var PlusSvg = function PlusSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M22.5882 10.5882H13.4118V1.41176C13.4118 0.635294 12.7765 0 12 0C11.2235 0 10.5882 0.635294 10.5882 1.41176V10.5882H1.41176C0.635294 10.5882 0 11.2235 0 12C0 12.7765 0.635294 13.4118 1.41176 13.4118H10.5882V22.5882C10.5882 23.3647 11.2235 24 12 24C12.7765 24 13.4118 23.3647 13.4118 22.5882V13.4118H22.5882C23.3647 13.4118 24 12.7765 24 12C24 11.2235 23.3647 10.5882 22.5882 10.5882Z",
    fill: "currentColor"
  }));
};
PlusSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var PositiveSvg = function PositiveSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12C1 5.92 5.92 1 12 1C18.08 1 23 5.92 23 12C23 18.08 18.08 23 12 23C5.92 23 1 18.08 1 12ZM2.3 12C2.3 17.35 6.65 21.7 12 21.7C17.35 21.7 21.7 17.35 21.7 12C21.7 6.65 17.35 2.29999 12 2.29999C6.65 2.29999 2.3 6.65 2.3 12ZM9.62998 14.87L16.23 8.27002C16.48 8.02002 16.9 8.02002 17.15 8.27002C17.4 8.52002 17.4 8.94 17.15 9.19L9.62998 16.71L6.22998 13.31C5.97998 13.06 5.97998 12.64 6.22998 12.39C6.47998 12.14 6.89998 12.14 7.14998 12.39L9.62998 14.87Z",
    fill: "currentColor"
  }));
};
PositiveSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var SearchSvg = function SearchSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M23.7428 22.4896L17.9612 16.7316C17.5711 16.3414 17.4883 15.7148 17.8075 15.2537C19.1199 13.3265 19.7702 10.9145 19.4037 8.32517C18.7889 3.99782 15.2064 0.545407 10.8554 0.0606493C4.60082 -0.625106 -0.625106 4.60083 0.0606494 10.8554C0.533584 15.1946 3.98601 18.7888 8.31336 19.4037C10.8908 19.7702 13.3146 19.1317 15.2418 17.8193C15.703 17.5001 16.3178 17.5829 16.7198 17.973L22.4896 23.7428C22.6669 23.9202 22.8916 24.003 23.1162 24.003C23.3408 24.003 23.5655 23.9202 23.7428 23.7428C24.0857 23.4 24.0857 22.8324 23.7428 22.4896ZM1.76321 9.76762C1.76321 5.36933 5.34569 1.78685 9.74398 1.78685C14.1423 1.78685 17.7248 5.36933 17.7248 9.76762C17.7248 14.1659 14.1423 17.7484 9.74398 17.7484C5.34569 17.7484 1.76321 14.1659 1.76321 9.76762Z",
    fill: "currentColor"
  }));
};
SearchSvg.defaultProps = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var TickSvg = function TickSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.60544 22L0.390108 14.4984C-0.130036 13.9576 -0.130036 13.0841 0.390108 12.5433C0.910253 12.0026 1.75048 12.0026 2.27063 12.5433L7.60544 18.0898L21.7294 3.40558C22.2495 2.86481 23.0897 2.86481 23.6099 3.40558C24.13 3.94636 24.13 4.81997 23.6099 5.36074L7.60544 22Z",
    fill: "currentColor"
  }));
};
TickSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var WarningSvg = function WarningSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 1C5.92 1 1 5.93 1 12C1 18.07 5.92 23 12 23C18.08 23 23 18.08 23 12C23 5.92 18.08 1 12 1ZM11 5H13V14H11V5ZM12 19C11.17 19 10.5 18.33 10.5 17.5C10.5 16.67 11.17 16 12 16C12.83 16 13.5 16.67 13.5 17.5C13.5 18.33 12.83 19 12 19Z",
    fill: "currentColor"
  }));
};
WarningSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var icons = {
  arrow_down: ArrowDownSvg,
  arrow_left: ArrowLeftSvg,
  arrow_right: ArrowRightSvg,
  arrow_up: ArrowUpSvg,
  chevron_down: ChevronDownSvg,
  chevron_left: ChevronLeftSvg,
  chevron_right: ChevronRightSvg,
  chevron_up: ChevronUpSvg,
  close: CloseSvg,
  cross: CloseSvg,
  home: HomeSvg,
  information: InformationSvg,
  menu: MenuSvg,
  minus: MinusSvg,
  negative: NegativeSvg,
  padlock: PadlockSvg,
  plus: PlusSvg,
  positive: PositiveSvg,
  search: SearchSvg,
  tick: TickSvg,
  warning: WarningSvg
};
export default icons;